'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessagingController = function () {
  function MessagingController(authService, messagingService, loadingService, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, MessagingController);
    this.authService = authService;
    this.messagingService = messagingService;
    this.loadingService = loadingService;
    this.$state = $state;

    this.filterParams = {};
  }

  (0, _createClass3.default)(MessagingController, [{
    key: 'reset',
    value: function reset() {
      var ctrl = this;

      this.filterParams.userId = this.authService.authData.userId;
      this.filterParams.messagesType = this.activeTab;

      this.pagination = {
        totalItems: 0,
        currentPage: 1,
        pageSize: 10
      };

      this.filterParams.pageCriteria = {
        pageStart: 0,
        itemsToFetch: this.pagination.pageSize,
        sortExpression: 'received',
        ascending: false
      };

      this.notification = {
        type: 'info',
        msg: ''
      };

      this.listMessages();
    }
  }, {
    key: 'updatePageIndex',
    value: function updatePageIndex() {
      if (this.pagination.currentPage === 1) {
        this.filterParams.pageCriteria.pageStart = 0;
      } else {
        this.filterParams.pageCriteria.pageStart = (this.pagination.currentPage - 1) * this.pagination.pageSize;
      }
    }
  }, {
    key: 'updateSort',
    value: function updateSort(fieldName) {
      if (this.filterParams.pageCriteria.sortExpression === fieldName) {
        this.filterParams.pageCriteria.ascending = !this.filterParams.pageCriteria.ascending;
      } else {
        this.filterParams.pageCriteria.sortExpression = fieldName;
        this.filterParams.pageCriteria.ascending = true;
      }

      this.listMessages();
    }
  }, {
    key: 'listMessages',
    value: function listMessages() {
      var ctrl = this;

      ctrl.updatePageIndex();

      ctrl.loadingService.showLoading('messagingListing', 'Loading Messages ...');

      ctrl.messagingService.listMessages(ctrl.filterParams).then(function (response) {
        ctrl.messages = response.data.items;
        ctrl.pagination.totalItems = response.data.totalRecords;

        if (ctrl.pagination.totalItems === 0) {
          ctrl.notification = {
            type: 'info',
            msg: 'No data to display'
          };
        } else {
          var pageEnd = ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize < response.data.totalRecords ? ctrl.filterParams.pageCriteria.pageStart + ctrl.pagination.pageSize : response.data.totalRecords;

          ctrl.notification = {
            type: 'info',
            msg: 'Currently display ' + (ctrl.filterParams.pageCriteria.pageStart + 1) + ' to ' + pageEnd + ' out of ' + ctrl.pagination.totalItems + ' messages'
          };
        }
      }).catch(function (err) {
        ctrl.notification = {
          type: 'error',
          msg: "An error occurred while fetching messages." + (err.data ? err.data.messageDetail : '')
        };
      }).finally(function () {
        ctrl.loadingService.hideLoading('messagingListing');
      });
    }
  }, {
    key: 'viewMessage',
    value: function viewMessage(message) {
      if (!message.read) {
        this.authService.authData.msgCount--;
      }

      this.$state.go('messageView', { messageId: message.messageId });
    }
  }, {
    key: 'showInbox',
    value: function showInbox() {
      this.activeTab = 'inbox';
      this.reset();
    }
  }, {
    key: 'showOutbox',
    value: function showOutbox() {
      this.activeTab = 'outbox';
      this.reset();
    }
  }]);
  return MessagingController;
}();

exports.default = MessagingController;


// WEBPACK FOOTER //
// ./client/app/components/messaging/messaging.controller.js